/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import React, { useEffect, useRef, useState } from 'react';
import '@/styles/maintenance-notice.css';
import {
  formatHHMM,
  getActiveMaintenanceSlot,
  Slot,
} from '@/lib/maintenance-logic.ts';

export const MaintenanceNotice: React.FC = () => {
  const [slot, setSlot] = useState<Slot | null>(null);
  const [hiddenForSlotId, setHiddenForSlotId] = useState<number | null>(null);
  const prevActive = useRef<boolean>(false);

  /**
   * @experimental
   */
  useEffect(() => {
    const check = () => {
      const active = getActiveMaintenanceSlot();
      const isActive = Boolean(active);

      if (prevActive.current === true && isActive === false) {
        setHiddenForSlotId(null);
      }

      prevActive.current = isActive;
      setSlot(active || null);
    };

    check();
    const interval = setInterval(check, 30_000);
    return () => clearInterval(interval);
  }, []);

  if (!slot) return null;
  if (hiddenForSlotId === slot.id) return null;

  return (
    <div className="maintenance-notice show">
      <div>
        Внимание: <span className="italic">{slot.title}</span>{' '}
        <b>
          с {formatHHMM(slot.start)} до {formatHHMM(slot.end)} МСК
        </b>
        . Возможны кратковременные перебои в работе.
        <br />
      </div>
      <div className="notice-buttons">
        <button onClick={() => setHiddenForSlotId(slot.id)}>Скрыть</button>
      </div>
    </div>
  );
};


export const MaintenanceNoticeStatic: React.FC = () => {
  const [slot, setSlot] = useState<Slot | null>(null);

  useEffect(() => {
    const check = () => {
      const active = getActiveMaintenanceSlot();
      setSlot(active);
    };

    check();
    const interval = setInterval(check, 30_000);
    return () => clearInterval(interval);
  }, []);

  if (!slot) return null;

  return (
    <div className="maintenance-notice show">
      <div>
        Внимание: <span className="italic">{slot.title}</span> {" "}
        <b>
          с {formatHHMM(slot.start)} до {formatHHMM(slot.end)} МСК
        </b>
        . Возможны кратковременные перебои в работе.
        <br />
      </div>
    </div>
  );
};

